import { render, staticRenderFns } from "./PaymentDetailPage.vue?vue&type=template&id=bc1bdbda&"
import script from "./PaymentDetailPage.vue?vue&type=script&lang=ts&"
export * from "./PaymentDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports